const s = {
  name: "EmailLock",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,30H3.6l14.2-12.7l2.2,2L38,3.2V16h2V3c0-1.7-1.3-3-3-3H3C1.3,0,0,1.3,0,3v26c0,1.7,1.3,3,3,3h19V30z
			 M2,28.8V3.2L16.3,16L2,28.8z M3.6,2h32.8L20,16.7l-1.6-1.4L3.6,2z"/>
		<path class="st0" d="M32,25v3h2v-3H32z"/>
		<path class="st0" d="M40,21h-3v-1c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4v1h-3v11h14V21z M28,23h10v7H28V23z M35,20v1h-4v-1
			c0-1.1,0.9-2,2-2S35,18.9,35,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EmailLock
};
